import Radio from "../../components/Radio/Radio"
import '../../styles/Components.css';
import '../../styles/PVIPage.css'
import ReturnButton from '../../components/BoutonRetour/ReturnButton'
import ImageUploading from "react-images-uploading";
import { useState } from 'react';
import { Delete } from "@mui/icons-material";
import { ModeEdit } from '@mui/icons-material';
import Bouton from "../../components/Bouton/Bouton"
import "../../styles/Recap.css"
import carousel from "bootstrap/js/src/carousel";
import Requetes from "../../services/Requetes";

const RecapDepannage = () => {
    const [depannage, setDepannage] = useState({})

    const handleChange = ({currentTarget}) => {
        const {name, value} = currentTarget;
        setDepannage({...depannage, [name] : value})
    }

    const [images, setImages] = useState([]);

    const onChange = (imageList, addUpdateIndex) => {
        // data for submit
        setImages(imageList);
    };

    const handleSubmit = async () => {
        try {
            let formData = new FormData()
            formData.append("depannage", JSON.stringify(depannage))
            await Requetes.createDepannage(formData);
        } catch (e) {
            console.log(e)
        }
    }

    const autreInstallateur = () => {
        document.getElementById("installateur_autre").checked === false ?
            document.getElementById("inpAutreInstall").style.display = "none" :
            document.getElementById("inpAutreInstall").style.display = "initial"

    }

    const maxNumber = 100;
    const NewEquip = () => {
        const inpsEquip = Array.from(
            document.getElementsByClassName("equip"))
        inpsEquip.forEach(element => {
            element.type === "text" ?
                element.value = "" :
                element.checked = false
        })
    }

    return (
        <div className='DepannagePage'>
            <div className='header'>
                <ReturnButton title={"Modification dépannage"} text=""
                    link={"/depannage"} />
            </div>
            <div className='bordureDepannage'>
                <div className="DepannageComponent">
                    <h3>Détenteur:</h3>
                    <p>Société: </p><input className="inpDepannage" type="text" name={"societe"} value={depannage.societe} onChange={handleChange}/>
                    <p>Nom: </p><input className="inpDepannage" type="text" name={"nom"} value={depannage.nom} onChange={handleChange}/>
                    <p>Prénom: </p><input className="inpDepannage" type="text" name={"prenom"} value={depannage.prenom} onChange={handleChange}/>
                    <p>Tél: </p><input className="inpDepannage" type="text" name={"telephone"} value={depannage.telephone} onChange={handleChange}/>
                    <p>Mail: </p><input className="inpDepannage" type="text" name={"mail"} value={depannage.mail} onChange={handleChange}/>
                </div>
                <div className="DepannageComponent mt-3">
                    <h3>Site</h3>
                    <p>Nom de l'établissement: </p><input className="inpDepannage" type="text" name={"etablissement"} value={depannage.etablissement} onChange={handleChange}/>
                    <p>Adresse: </p><input className="inpDepannage" type="text" name={"adresse"} value={depannage.adresse} onChange={handleChange}/>
                    <p>Zone de l'intervention: </p><input className="inpDepannage" type="text" name={"zoneIntervention"} value={depannage.societe} onChange={handleChange}/>
                </div>
                <div className="Equipement DepannageComponent mt-3">
                    <h3>Installateur</h3>
                    <div>
                        <Radio name={"installateur"} inpClass={"equip"} label={"MEA"} className={"radioDepannage"} onChange={handleChange} id={"installateur_MEA"} checked={false}></Radio>
                        <Radio name={"installateur"} inpClass={"equip"} label={"Autre"} className={"radioDepannage"} onChange={autreInstallateur} id={"installateur_autre"} checked={true}></Radio>
                    </div>
                    <input className="equip inpDepannage" id="inpAutreInstall" type="text" />
                    <p>Marque + Modèle </p><input className="equip inpDepannage" type="text" />
                    <div>
                        <p style={{ marginBottom: "-10px" }}>Photo de la plaque signalétique:</p>
                        <ImageUploading
                            multiple={false}
                            value={images}
                            onChange={onChange}
                            maxNumber={maxNumber}
                            dataURLKey="data_url">
                            {({
                                imageList,
                                onImageUpload,
                                onImageRemoveAll,
                                onImageUpdate,
                                onImageRemove,
                                isDragging,
                                dragProps
                            }) => (<>
                                <div className="upload__image-wrapper">

                                    <div className='buttonsContainerPhotos'>
                                        <button
                                            style={isDragging ? { color: "red" } : null}
                                            onClick={onImageUpload}
                                            className={images.length !== 0 ? "duo" : "solo"}
                                            {...dragProps}
                                        >
                                            Selectionner une photo
                                        </button>
                                        {images.length !== 0 && <>
                                            &nbsp;
                                            <button onClick={onImageRemoveAll} className="duo" style={{ backgroundColor: "red", borderColor: "red" }}>Déselectionner
                                                la photo</button>
                                        </>
                                        }
                                    </div>

                                    <div className='ImagesWrapper'>

                                        {imageList.map((image, index) => (

                                            <div key={index} className="image-item">
                                                <img src={image.data_url} alt="" width="130" />

                                                <div className="image-item__btn-wrapper">
                                                    <button onClick={() => onImageUpdate(index)} style={{ border: "none" }} ><ModeEdit color="primary" /></button>
                                                    <button onClick={() => onImageRemove(index)}><Delete color="error" /></button>
                                                </div>

                                            </div>
                                        ))}
                                    </div>
                                </div>
                                {images.length !== 0 &&
                                    <button onClick={handleSubmit} className="envoiPhotosButton">Valider la photo</button>
                                }
                            </>
                            )}

                        </ImageUploading>
                    </div>
                    <p><b>Objet du dépannage</b></p><input className="equip inpDepannage" type="text" />
                    <p><b>Note interne</b> </p><input className="equip inpDepannage" type="text" />
                    <p><b>Observations</b> </p><input className="equip inpDepannage" type="text" />
                    <div>
                        <Radio name={"Afaire"} inpClass={"equip"} label={"Devis"} className={"radioDepannage"} onChange={handleChange} id={"Afaire_Devis"} checked={false}></Radio>
                        <Radio name={"Afaire"} inpClass={"equip"} label={"Replanifier"} className={"radioDepannage"} onChange={handleChange} id={"Afaire_Replanifier"} checked={false}></Radio>
                        <Radio name={"Afaire"} inpClass={"equip"} label={"Équipement mis en service"} className={"radioDepannage"} onChange={handleChange} id={"Afaire_EMES"} checked={false}></Radio>
                    </div>
                </div>
                <input type="button" className="btn btn-primary" value="Ajouter équipement" onClick={handleSubmit} />
            </div >
        </div>
    )
}

export default RecapDepannage